import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';

import styles from './index.module.scss';

const T_PREFIX = 'freelancer_page.overview';

/** @type {import('./index').SellerCounts} */
export const SellerCounts = ({ className, ordersCount, repeatBuyersCount }) => {
    const delimiter = <span className={classnames(styles.delimiter, 'm-r-24 m-l-24')} />;

    const nodes = [];

    if (ordersCount) {
        nodes.push(
            <div className="flex flex-col flex-items-end">
                <div className="tbody-2 text-bold co-text-darker">{ordersCount}</div>
                <div className="tbody-7">
                    <I18n k={`${T_PREFIX}.completed_orders`} />
                </div>
            </div>
        );
    }

    if (repeatBuyersCount) {
        if (!isEmpty(nodes)) {
            nodes.push(delimiter);
        }

        nodes.push(
            <div className="flex flex-col flex-items-end">
                <div className="tbody-2 text-bold co-text-darker">{repeatBuyersCount}</div>
                <div className="tbody-7">
                    <I18n k={`${T_PREFIX}.repeating_buyers`} />
                </div>
            </div>
        );
    }

    if (isEmpty(nodes)) {
        return null;
    }

    return <div className={classnames(className, styles.sellerCounts, 'flex')}>{nodes}</div>;
};
